import { AlertCircle } from 'lucide-react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'

type Reason = 'no-subscription' | 'fetch-failed' | 'config-missing'

interface ErrorScreenProps {
  reason: Reason
  onRetry: () => void
}

const COPY: Record<Reason, { title: string; description: string }> = {
  'no-subscription': {
    title: 'No subscriptions available',
    description:
      'Your account has no subscriptions assigned, so there’s nothing to build links for. Contact your administrator.',
  },
  'fetch-failed': {
    title: 'Couldn’t reach the server',
    description:
      'The link builder couldn’t load its configuration. Check your network connection and try again.',
  },
  'config-missing': {
    title: 'App configuration not injected',
    description:
      'The runtime config script wasn’t replaced before the page was served. This is a deployment issue — reload to retry, then contact your administrator if it persists.',
  },
}

export function ErrorScreen({ reason, onRetry }: ErrorScreenProps) {
  const { title, description } = COPY[reason]
  return (
    <div className="flex h-dvh items-center justify-center p-6">
      <Alert variant="destructive" className="max-w-md">
        <AlertCircle aria-hidden />
        <AlertTitle>{title}</AlertTitle>
        <AlertDescription>
          <p>{description}</p>
          <Button variant="outline" size="sm" onClick={onRetry} className="mt-3 self-start">
            Retry
          </Button>
        </AlertDescription>
      </Alert>
    </div>
  )
}
